import React from "react"
import { toast } from "react-toastify"
import { useAppToast } from "@app"

import AppConfirmToast from "@components/@base/ConfirmToast"


export default function useToast() {
    const {showToast} = useAppToast()

    // Same confirmation as the framework's (same toast, same 8 s, no close button, closes on either answer),
    // drawn in the app's look; title / tone / icon are optional and only change how it reads
    const confirm = (msg, { onSubmit, submitText, onCancel, cancelText, title, tone = 'info', icon, ...config } = {}) => toast.info(
        React.createElement(AppConfirmToast, { msg, title, tone, icon, onSubmit, submitText, onCancel, cancelText }),
        { closeButton: false, autoClose: 8e3, icon: false, className: `app-toast-${tone}`, ...config }
    )

    return {
        showToast: {
            ...showToast,
            confirm,
        }
    }
}
